import './App.css';
import LoginForm from './components/loginForm';
import SalesForm from './components/sales/TBD_salesForm';
import SalesList from './components/sales/salesList';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ProtectedRoute } from './routes/protectedRoute';
import { UserProvider } from './context/userContext';
import CreateSalesForm from './components/sales/createSalesForm';
import AdminSalesList from './components/admin/adminSalesList';
import SalesCommissionList from './components/accountant/salesCommissionList';
import { HeaderNavbar } from './components/navbar/headerNavbar';
import { UpdatePasswordForm } from './components/agent/updatePasswordForm';
import TBD_AdminSalesList from './components/admin/TBD_adminSalesList';
import WebbeyCommissionList from './components/accountant/webbeyCommissionList';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TBD_salesForm from './components/sales/TBD_salesForm';
import GeneralCommissionProgressList from './components/common/commission/generalCommissionProgressList';
import { getCommissionProgressByAgentId } from './api/commissionProgressApi';
import { UserProfile } from './components/agent/userProfile';
import { SideNavbar } from './components/navbar/sideNavbar';
import { MainLayout } from './components/layout/MainLayout';
import DashboardBK from './components/dashboard/dashboardBK';
import { DashboardTest } from './components/dashboard/dashboardTest';
import NotFound from './components/common/notFound';

function AppContent() {
  // const location = useLocation();
  // const { isAuthenticated, authChecked } = useUserAuth();
  // const showHeader = location.pathname !== "/" && isAuthenticated === true && authChecked === true;

  // const validHeaderRoutes = ["/sales", "/sales/create", "/sales/createSales"];
  // const isValidRoute = validHeaderRoutes.some(path => location.pathname.startsWith(path));

  return (
    <div>
      {/* {isValidRoute && <Header />} */}
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route path="/dashboardBK" element={
          <ProtectedRoute>
            <MainLayout>
              <DashboardBK />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <MainLayout>
              <DashboardTest />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/sales" element={
          <ProtectedRoute>
            <MainLayout>
              <SalesList />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/sales/create" element={
          <ProtectedRoute>
            <MainLayout>
              <CreateSalesForm />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/sales/createSales" element={
          <ProtectedRoute>
            <MainLayout>
              <SalesForm />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/admin/sales" element={
          <ProtectedRoute requiredRoles={["Admin", "Super Admin"]}>
            <MainLayout>
              <AdminSalesList />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/accounting/salesCommissions" element={
          <ProtectedRoute requiredRoles={["Accountant", "Super Admin"]}>
            <MainLayout>
              <SalesCommissionList />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/user/changePassword" element={
          <ProtectedRoute>
            <MainLayout>
              <UpdatePasswordForm />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/user/profile" element={
          <ProtectedRoute>
            <MainLayout>
              <UserProfile />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/tbdSalesForm" element={
          <ProtectedRoute>
            <MainLayout>
              <TBD_salesForm />
            </MainLayout>
          </ProtectedRoute>
        } />

        <Route path="/commissions/psc" element={
          <ProtectedRoute>
            <MainLayout>
              <GeneralCommissionProgressList
                commPayType="PSC"
                fetchApi={getCommissionProgressByAgentId}
                withUserId={true} />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/commissions/doc" element={
          <ProtectedRoute>
            <MainLayout>
              <GeneralCommissionProgressList
                commPayType="DOC"
                fetchApi={getCommissionProgressByAgentId}
                withUserId={true} />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/commissions/toc" element={
          <ProtectedRoute>
            <MainLayout>
              <GeneralCommissionProgressList
                commPayType="TOC"
                fetchApi={getCommissionProgressByAgentId}
                withUserId={true} />
            </MainLayout>
          </ProtectedRoute>
        } />

        <Route path="/customers" element={
          <ProtectedRoute>
            <MainLayout>
              <div className="container mt-4"><h2>Customers (Coming Soon)</h2></div>
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/reports/commission" element={
          <ProtectedRoute>
            <MainLayout>
              <div className="container mt-4"><h2>Commission Report (Coming Soon)</h2></div>
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/reports/customer" element={
          <ProtectedRoute>
            <MainLayout>
              <div className="container mt-4"><h2>Customer Report (Coming Soon)</h2></div>
            </MainLayout>
          </ProtectedRoute>
        } />

        <Route path="/admin/group" element={
          <ProtectedRoute requiredRoles={["Admin", "Super Admin"]}>
            <MainLayout>
              <div className="container mt-4"><h2>Admin Group (Coming Soon)</h2></div>
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/admin/agents" element={
          <ProtectedRoute requiredRoles={["Admin", "Super Admin"]}>
            <MainLayout>
              <div className="container mt-4"><h2>Admin Agents (Coming Soon)</h2></div>
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/accounting/overview" element={
          <ProtectedRoute requiredRoles={["Accountant", "Super Admin"]}>
            <MainLayout>
              <div className="container mt-4"><h2>Accounting Overview (Coming Soon)</h2></div>
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/accounting/webbeyCommissions" element={
          <ProtectedRoute requiredRoles={["Accountant", "Super Admin"]}>
            <MainLayout>
              <WebbeyCommissionList />
            </MainLayout>
          </ProtectedRoute>
        } />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <UserProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </UserProvider>
    </LocalizationProvider>
    // <TBD_salesForm />
  );
}
